var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarFilled = function SvgStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.673 1.424a.751.751 0 0 0-1.35 0L4.816 4.525l-3.365.497a.748.748 0 0 0-.418 1.275l2.443 2.416-.577 3.415a.752.752 0 0 0 1.095.788L7 11.31l3.007 1.606a.75.75 0 0 0 1.094-.788l-.579-3.415 2.443-2.416a.75.75 0 0 0-.418-1.275L9.18 4.525z"
  })));
};
export default SvgStarFilled;